import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrTime } from '../../../../../../shared/types/paramPqrTimes';

export const usePqrTimesRegisterHistory = (pqrTimes?: PqrTime) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = pqrTimes || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [pqrTimes]);

    return {
        formik,
    };
};
